const dynamicParameterFields = {
    required: "This field is required",
    notSupportedField: "This field type is not supported",
    parametersNotNecessary: "Parameters are not necessary for this workflow",
    autoFilled: "From Tool",
    autoFilledFromIntegration: "Field automatically filled from selected tool"
};

export default dynamicParameterFields;